'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThSmall = function TiThSmall(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 31.7c0 2.3-1.9 4.1-4.2 4.1s-4.1-1.8-4.1-4.1c0-2.3 1.8-4.2 4.1-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.1-1.9-4.1-4.2c0-2.3 1.8-4.2 4.1-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.1-1.9-4.1-4.2c0-2.3 1.8-4.1 4.1-4.1s4.2 1.8 4.2 4.1z m11.7 23.4c0 2.3-1.9 4.1-4.2 4.1s-4.2-1.8-4.2-4.1c0-2.3 1.9-4.2 4.2-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2s4.2 1.9 4.2 4.2z m0-11.7c0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.1 4.2-4.1s4.2 1.8 4.2 4.1z m11.6 23.4c0 2.3-1.8 4.1-4.1 4.1s-4.2-1.8-4.2-4.1c0-2.3 1.9-4.2 4.2-4.2s4.1 1.9 4.1 4.2z m0-11.7c0 2.3-1.8 4.2-4.1 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2s4.1 1.9 4.1 4.2z m0-11.7c0 2.3-1.8 4.2-4.1 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.1 4.2-4.1s4.1 1.8 4.1 4.1z' })
        )
    );
};

exports.default = TiThSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-small.js
// module id = 2223
// module chunks = 0